<template>
  <div class="table">
    <div class="searchRow row">
      <div class="col-12 col-md-4 showCountBoagt">
        Show:
        <span
          v-for="option in showOptions"
          :key="option"
          @click="() => {itemsPerPage = option; pageNumber = 0;}"
          :class="{current: itemsPerPage == option}"
          class="displayOption"
        >
          <span class="displayOptionText">{{option == 10000 ? 'All' : option}}</span>
        </span>
      </div>
      <div class="boagt-search-container col-12 offset-md-4 col-md-4 alignment">
        <SearchBar :searchFunc="(val) => {this.search = val}" placeholder="Search" ref="searchBar"/>
      </div>
    </div>
    <div class="row">
      <table class="boagtTable">
        <thead>
          <th><h3>Category</h3></th>
          <th><h3>Brand</h3></th>
          <!-- <th><h3>Catalogue</h3></th> -->
        </thead>
        <tbody ref="tableBody">
          <tr v-for="(row, index) in this.paginated" :key="index">
            <td class="col-1" v-html="row['Category-a']"></td>
            <td class="col-2" v-html="row['Brand']"></td>
            <!-- <td class="col-3" v-html="row['Catalogue']"></td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <PaginationButtons class="paginationRemoveBullet" :pageNumber="pageNumber" :pageCount="pageCount" />
  </div>
</template>

<script>

import SearchBar from "@/components/searchBar"
import PaginationButtons from "@/components/paginationButtons"

export default {
  name: 'Boagt',
  components: {
    SearchBar,
    PaginationButtons
  },
  data:()=>{
    return{
      search: '',
      itemsPerPage:20,
      showOptions:[10,20,50,100,500,10000],
    }
  },
  props:["content"],
  mounted(){
  },
  methods:{
    lastCat(cat){
      if(cat == this.last){
        return false;
      } else{
        this.last = cat
        return true;
      }
    }
  },
  computed:{
    tableData() {
      let row = /(<tr.*>)(\n.*)/gm
      let dataTag = /(<t[hd] class="column-\d">)|(<\/t[hd]>)/gm
      let data = []
      let header = []
      let rows = this.content.match(row)
      for (let i in rows){
        let cols = rows[i].split(dataTag)
        cols.shift()
        let rowData = {}
        let j = 0
        for (let str of cols){
          if(str!=undefined && str!='' && str!="0" && str!="Sort" && !str.match(dataTag)){
            if(i == 0){
              header.push(str)
            } else{
              rowData[header[j]] = str
              j++
            }
          }
        }
        data.push(rowData)
      }
      data.shift()
      return data
    },
    filtered(){
      let search = this.search.toLowerCase()
      let filter = []
      for(let item of this.tableData){
        if(item['Category-a'].toLowerCase().indexOf(search) > -1 || item['Brand'].toLowerCase().indexOf(search) > -1){// || item['Catalogue'].toLowerCase().indexOf(search) > -1){
          filter.push(item)
        }
      }
      return filter
    },
    paginated() {
      const start = (this.pageNumber - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      let paginated = JSON.parse(JSON.stringify(this.filtered.slice(start, end))); //Clone the array and it's objects
      let last = ''
      //Filter out duplicate mentions of a category in the cloned list so that they only appear once
      for(let item of paginated){
        if(item['Category-a'] == last){
          item['Category-a']=''
        } else {
          last = item['Category-a']
        }
      }
      return paginated
    },
    pageCount() {
      let l = this.filtered.length,
        s = this.itemsPerPage;
      return Math.ceil(l / s);
    },
    pageNumber: {
      get() {
        if (this.$route.query && this.$route.query.page) {
          return parseInt(this.$route.query.page);
        }
        return 1;
      },
      //when page number is set, update query param in route
      set(val) {
        // eslint-disable-next-line
        const { page, ...oldQuery } = this.$route.query;
        if (val === 0 || val === undefined || val === 1) {
          //remove page from query params if page number is 0
          this.$router.push({ query: { ...oldQuery } });
        } else {
          this.$router.push({ query: { page: val, ...oldQuery } });
        }
      }
    }
  }
}
</script>

<style lang="scss">
.alignment{
  padding:0;
  padding-bottom: 10px;
}

// .searchRow {
//   padding-top: 10px;
//   background: #ddd;
//   input{
//     border-color: #000 !important;
//   }
//   .searchIconContainer{
//     // background: $CTgreen !important;
//   }
// }

.boagtTable{
  width: 100%;
  th,td{
    width: 50%;
    padding-left:10px;
    box-sizing: border-box;
    overflow: auto;
  }
  th{
    background: #AF272F;
    h3{
      color: #fff;
    }
  }
  .col-1{
    font-weight: bold;
  }
}

.displayOption {
  &:not(:last-of-type)::after {
    content: " - ";
  }
}

.displayOptionText {
  cursor: pointer;
}

.displayOption.current .displayOptionText {
  text-decoration: underline;
}

.paginationRemoveBullet li::before{
  content:none !important;
}

@include media-breakpoint-down(md){
  th h3{
    font-size: 1.2em;
  }
  .showCountBoagt{
    padding: 10px 0;
  }
}
</style>
